module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"exportButton":"JSON-Export ohne GIS-Daten","exportButtonWithGis":"JSON-Export mit GIS-Daten","exportButtonImmopac":"Immopac-Export"}}')
  delete Component.options._Ctor
}
